import { useEffect, useRef, useState } from "react";
import { BackIcon } from "../../pages/commerceProfile";
import Card from "../Card";
import { ICardToggleProps } from "./cardToggle.props";
import { BodyCardToggle } from "./cardToggle.styled";

const CardToggle: React.FC<ICardToggleProps> = (
    {
        title,
        children,
        isShowToggleButton = true,
        isCollapse,
        onToggle,
        autoToggle,
        ...props
    }: ICardToggleProps
) => {
    const [isToggle, setIsToggle] = useState<boolean | undefined>(isCollapse);

    useEffect(() => {
        if (autoToggle) setIsToggle(false);
    }, [children])

    return <Card className="p-[20px] pb-[10px]">
        <div className="pb-[10px]">
            {
                title && typeof title === "string" ?
                    <h2 className="text-[1.0625rem] font-bold">{title}</h2>
                    : title
            }
        </div>
        <BodyCardToggle className={`${!isToggle ? "is-open" : ""}`}>
            <div className="inner">
                {children}
            </div>
        </BodyCardToggle>
        {
            isShowToggleButton && <div className="flex justify-center items-center">
                <button className="w-[30px] h-[30px] flex justify-center items-end" onClick={() => {
                    setIsToggle(!isToggle)
                    onToggle && onToggle(!isToggle)
                }}>
                    <div className={`rotate-90 inline-block transition duration-200 ease-linear ${isToggle ? "rotate-[270deg]" : ""}`}>
                        <BackIcon width={10} height={19} fillColor="#637381" />
                    </div>
                </button>
            </div>
        }
    </Card>
}

export default CardToggle